import React from 'react'
import {EditGuesser} from '@api-platform/admin'
import {TextInput} from 'react-admin';
import {useTranslation} from "react-i18next";

function Edit(props) {
    const {t} = useTranslation()

    return (
        <EditGuesser {...props}>
            <TextInput source="name" label={t('common.name')}/>
            <TextInput source="code" label={t('admin.code')}/>
        </EditGuesser>
    )
}

export default Edit
